import { AlertTriangle, Layers, Users, Cpu } from "lucide-react";
import { SectionHeader } from "@/components/sections/SectionHeader";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportConfig } from "@/lib/animations";

const crisisPoints = [
  {
    icon: Layers,
    title: "Rising operational complexity",
  },
  {
    icon: Users,
    title: "Fragmented decision-making",
  },
  {
    icon: AlertTriangle,
    title: "Informal systems that no longer scale",
  },
  {
    icon: Cpu,
    title: "AI pressure without a clear roadmap",
  },
];

export const WhySection = () => {
  return (
    <motion.section
      className="section-padding bg-background"
      initial="hidden"
      whileInView="visible"
      viewport={viewportConfig}
      variants={staggerContainer}
    >
      <div className="section-container">
        <motion.div variants={fadeInUp}>
          <SectionHeader
            eyebrow="Why Inductus Exists"
            title="The Reality Most Consultants Won't Say Aloud"
            centered={true}
          />
        </motion.div>

        <div className="max-w-3xl mx-auto text-center mb-16">
          <motion.p
            className="body-large text-muted-foreground mb-8"
            variants={fadeInUp}
          >
            Small and mid-sized businesses are the backbone of the American economy — 
            yet they face a unique crisis:
          </motion.p>

          {/* Crisis Points */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12"
            variants={staggerContainer}
          >
            {crisisPoints.map((point, index) => (
              <motion.div
                key={index}
                className="flex items-center gap-4 p-6 bg-secondary rounded-none border border-border"
                variants={fadeInUp}
                whileHover={{ y: -2, transition: { duration: 0.2 } }}
              >
                <point.icon size={24} className="text-muted-foreground flex-shrink-0" />
                <span className="font-sans text-base text-foreground">{point.title}</span>
              </motion.div>
            ))}
          </motion.div>

          {/* Gap Statement */}
          <motion.div className="space-y-6" variants={fadeInUp}>
            <p className="body-base text-muted-foreground">
              Big consulting firms are too expensive and detached.
              <br />
              Local advisors are too tactical and outdated.
            </p>

            <div className="divider mx-auto" />

            <motion.div
              className="bg-primary text-primary-foreground p-8 rounded-none"
              whileHover={{ scale: 1.01, transition: { duration: 0.2 } }}
            >
              <h3 className="heading-4 mb-4">Inductus International Exists in the Gap</h3>
              <p className="body-base text-primary-foreground/80">
                We bring institutional consulting discipline, AI-era intelligence, and 
                owner-level pragmatism to businesses that actually move the economy.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};
